import React, {useState, useEffect, useRef, useContext, useCallback} from 'react'
import {Container,Stack} from 'react-bootstrap'

export const Activities = () => {

	return <Container fluid>
				<h1>Home Page</h1>
			</Container>
}